import { th, zIndexes } from 'style/theme';
import { sizes } from 'style';
import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

export const Backdrop = styled(motion.div)`
  position: fixed;
  z-index: ${zIndexes.overlay};
  background-color: ${th('colors.blueBayoux')};
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow: scroll;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  ${({ isScrollable }) =>
    !isScrollable &&
    css`
      @media ${sizes.tabletPortrait} {
        align-items: center;
        overflow: hidden;
        padding-bottom: 0;
        padding-top: 0;
        height: 100vh;
      }
    `};

  @media ${sizes.desktop} {
    background-color: rgba(39, 60, 73, 0.9);
  }
`;

export const Modal = styled(motion.div)`
  width: 100%;
  height: auto;
  background-color: ${({ background }) => background};
  transition: background-color 0.3s;
  color: ${th('colors.black')};
  position: relative;

  @media ${sizes.desktop} {
    box-shadow: ${th('shadows.small')};
    width: 975px;
    height: 605px;
    border-radius: 10px;
    padding: 20px;
  }
`;
